// メッセージMap
export const MessageMap = {
    "current_password": "現在パスワード",
    "new_password": "新しいパスワード",
    "new_password_reenter": "新しいパスワード(再入力)"
};